import React, { useState, useEffect } from 'react';
import { Activity, X } from 'lucide-react';

const LiveActivityFeed = () => {
  const activities = [
    { user: 'Budi S.', location: 'Jakarta', action: 'dapat Rp 2,4 juta hari ini', time: '2 menit lalu' },
    { user: 'Siti N.', location: 'Bandung', action: 'mulai copy Algo Master', time: '5 menit lalu' },
    { user: 'Andi W.', location: 'Surabaya', action: 'tarik profit Rp 5,8 juta', time: '8 menit lalu' },
    { user: 'Rina P.', location: 'Medan', action: 'gabung Sahara AI', time: '12 menit lalu' },
    { user: 'Dedi H.', location: 'Semarang', action: 'copy 3 strategi', time: '15 menit lalu' },
    { user: 'Lina A.', location: 'Yogyakarta', action: 'dapat Rp 1,9 juta hari ini', time: '18 menit lalu' }
  ];

  const [currentActivity, setCurrentActivity] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [isMinimized, setIsMinimized] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentActivity((prev) => (prev + 1) % activities.length);
        setIsVisible(true);
      }, 300);
    }, 5000);

    return () => clearInterval(interval);
  }, [activities.length]);

  const activity = activities[currentActivity];

  if (isMinimized) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '5px',
      left: '5px',
      zIndex: 999,
      maxWidth: '280px',
      width: '100%'
    }}>
      <div style={{
        background: 'linear-gradient(135deg, #1a1a1a 0%, #0a0a0a 100%)',
        border: '2px solid #E31837',
        borderRadius: '12px',
        padding: '12px 14px',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.4), 0 0 30px rgba(227, 24, 55, 0.3)',
        backdropFilter: 'blur(10px)',
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateX(0) scale(1)' : 'translateX(-50px) scale(0.9)',
        transition: 'all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
        position: 'relative',
        animation: isVisible ? 'slideInBounce 0.6s ease-out' : 'none'
      }}>
        {/* Close Button */}
        <button
          onClick={() => setIsMinimized(true)}
          style={{
            position: 'absolute',
            top: '6px',
            right: '6px',
            background: 'rgba(255, 255, 255, 0.1)',
            border: 'none',
            borderRadius: '50%',
            width: '20px',
            height: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(227, 24, 55, 0.3)';
            e.currentTarget.style.transform = 'scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          <X style={{ width: '12px', height: '12px', color: '#FFFFFF' }} />
        </button>

        <div style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '10px'
        }}>
          {/* Pulse Icon */}
          <div style={{
            position: 'relative',
            flexShrink: 0,
            marginTop: '2px'
          }}>
            <div style={{
              position: 'absolute',
              width: '28px',
              height: '28px',
              background: '#FF1744',
              borderRadius: '50%',
              opacity: 0.3,
              animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
            }}></div>
            <div style={{
              width: '28px',
              height: '28px',
              background: 'linear-gradient(135deg, #E31837, #FF1744)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              boxShadow: '0 0 15px rgba(227, 24, 55, 0.6)',
              animation: 'iconBounce 2s ease-in-out infinite'
            }}>
              <Activity style={{ width: '14px', height: '14px', color: '#FFFFFF' }} />
            </div>
          </div>

          {/* Content */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              marginBottom: '4px'
            }}>
              <div style={{
                width: '6px',
                height: '6px',
                background: '#10B981',
                borderRadius: '50%',
                flexShrink: 0,
                animation: 'blink 2s ease-in-out infinite'
              }}></div>
              <span style={{
                fontSize: '9px',
                color: 'rgba(255, 255, 255, 0.6)',
                fontWeight: 500,
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>Live Activity</span>
            </div>
            <div style={{
              fontSize: '11px',
              color: '#FFFFFF',
              marginBottom: '3px',
              lineHeight: 1.3
            }}>
              <span style={{
                color: '#FF1744',
                fontWeight: 700
              }}>{activity.user}</span>
              <span style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '10px' }}> dari {activity.location}</span>
            </div>
            <div style={{
              fontSize: '10px',
              color: 'rgba(255, 255, 255, 0.9)',
              fontWeight: 500,
              marginBottom: '3px',
              lineHeight: 1.3
            }}>
              {activity.action}
            </div>
            <div style={{
              fontSize: '9px',
              color: 'rgba(255, 255, 255, 0.5)'
            }}>
              {activity.time}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            opacity: 0.3;
          }
          50% {
            transform: scale(1.4);
            opacity: 0.1;
          }
        }
        
        @keyframes blink {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.3;
          }
        }

        @keyframes slideInBounce {
          0% {
            transform: translateX(-100px) scale(0.8);
            opacity: 0;
          }
          50% {
            transform: translateX(10px) scale(1.05);
          }
          100% {
            transform: translateX(0) scale(1);
            opacity: 1;
          }
        }

        @keyframes iconBounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-3px);
          }
        }

        @media (max-width: 768px) {
          div[style*="bottom: 5px"] {
            bottom: 80px !important;
            left: 5px !important;
            max-width: 260px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default LiveActivityFeed;
